/**
 * @file: react
 * @author: Cuttle Cong
 * @date: 2017/11/9
 * @description: 
 */

module.exports = require('html-to-react')
module.exports.utils = require('html-to-react/lib/utils')


// WEBPACK FOOTER //
// ./~/picidae/exports/html-to-react.js